"use client";
import { useEffect, useState } from "react";
import { Form, FaucetSubHeader, Transactions } from "../../components/faucet";
import { Hash } from "@unlockdfinance/verislabs-web3";
import { isFaucetEnabled } from "app.config";
import { useRouter } from "next/navigation";

export default function Faucet(): JSX.Element {
  const router = useRouter();
  const [pendingTxHash, setPendingTxHash] = useState<Hash | null>(null);

  const handleNewTransaction = (txHash: Hash) => setPendingTxHash(txHash);

  useEffect(() => {
    !isFaucetEnabled() && router.push("/dashboard");
  }, []);

  return (
    <>
      <main className="relative overflow-hidden">
        {isFaucetEnabled() && (
          <>
            <FaucetSubHeader />
            <Form onNewTransaction={handleNewTransaction} />
            <Transactions
              className="mx-auto mb-5"
              pendingTxHash={pendingTxHash}
            />
          </>
        )}
        {/* <Faqs className="mx-auto md:mb-20 xs:mb-16 mb-8" /> */}
      </main>
    </>
  );
}
